








































































import Vue from 'vue';
import { API } from '@/api';
import { mapActions, mapGetters } from 'vuex';
import NewContacto from '@/components/propietarios/NewContacto.vue';

export default Vue.extend({
  components: {
    NewContacto,
  },
  props: {
    propietarioInit: Array,
    disabled: Boolean,
  },
  data: () => ({
    openDialog: false,
    headers: [
      // { text: 'Nombre', value: 'propietario.nombre' },
      { text: 'Tipo', value: 'tipo' },
      { text: 'Valor', value: 'value' },
      { text: 'Estado', value: 'estaActivo' },
    ],
    loading: false,
    options: {},
    total: 0,
    contactos: [],
    selected: [],
    propietario: {},
  }),
  methods: {
    ...mapActions(['getContactoList']),
    async loadData() {
      this.selected = [];
      this.loading = true;
      try {
        const admin = this.$store.getters.getAdmin;
        const condo = this.$store.getters.getCondo;
        const propietario = this.propietario;
        const datos = {admin, condo, propietario};
        console.log('getContactoList datos: %o', datos);
        const result = await this.$store.dispatch('getContactoList', datos);
        console.log('getContactoList result: %o', result);
        this.contactos = result;
        this.total = result.length;
      } catch (e) {
        console.error(e);
        this.$toast.error(e);
      }
      this.loading = false;
    },
    async activarContactos() {
      this.loading = true;
      let index = 0;
      const admin = this.$store.getters.getAdmin;
      const condo = this.$store.getters.getCondo;
      const propietario = this.propietario;
      for (const contacto of this.selected) {
        try {
          const datos = {admin, condo, propietario, contacto};
          console.log('enableContacto datos[%o]: %o', index, datos);
          const response = await this.$store.dispatch('enableContacto', datos);
          console.log('enableContacto response[%o]: %o', index, response);
        } catch (e) {
          console.error(e);
          this.$toast.error(e.response.data.message);
        }
        index++;
      }
      this.loading = false;
      this.loadData();
    },
    async desactivarContactos() {
      this.loading = true;
      let index = 0;
      const admin = this.$store.getters.getAdmin;
      const condo = this.$store.getters.getCondo;
      const propietario = this.propietario;
      for (const contacto of this.selected) {
        try {
          const datos = {admin, condo, propietario, contacto};
          console.log('disableContacto datos[%o]: %o', index, datos);
          const response = await this.$store.dispatch('disableContacto', datos);
          console.log('disableContacto response[%o]: %o', index, response);
        } catch (e) {
          console.error(e);
          this.$toast.error(e.response.data.message);
        }
        index++;
      }
      this.loading = false;
      this.loadData();
    },
    async eliminarContactos() {
      this.loading = true;
      let index = 0;
      const admin = this.$store.getters.getAdmin;
      const condo = this.$store.getters.getCondo;
      const propietario = this.propietario;
      for (const contacto of this.selected) {
        try {
          const datos = {admin, condo, propietario, contacto};
          console.log('eliminarContactos datos[%o]: %o', index, datos);
          const response = await this.$store.dispatch('deleteContacto', datos);
          console.log('eliminarContactos response[%o]: %o', index, response);
        } catch (e) {
          console.error(e);
          this.$toast.error(e.response.data.message);
        }
        index++;
      }
      this.loading = false;
      this.loadData();
    },
    pageEventHandler(event) {
      return;
    },
    estaActivoString(estaActivo) {
      if (estaActivo) {
        return 'Activo';
      } else if (!estaActivo) {
        return 'Inactivo';
      } else {
        return 'Estado indefinido';
      }
    },
    rowSelected(event) {
      const boolAndIndex = this.isContactoInArray(event, this.selected);
      const isInSelected = boolAndIndex.boolValue;
      const index = boolAndIndex.index;
      if (isInSelected) {
        this.selected.splice(index, 1);
      } else {
        this.selected.push(event);
      }
    },
    isContactoInArray(contacto, contactosArray) {
      const returnObject = {
        boolValue: false,
        index: 0,
      };
      let index = 0;
      for (const contact of contactosArray) {
        if (contact.id === contacto.id) {
          returnObject.boolValue = true;
          returnObject.index = index;
          return returnObject;
        }
        index++;
      }
      returnObject.boolValue = false;
      returnObject.index = -1;
      return returnObject;
    },
  },
  watch: {
    openDialog() {
      console.log('propietario: %o', this.propietarioInit);
      if (this.openDialog) {
        this.propietario = JSON.parse(JSON.stringify(this.propietarioInit[0]));
        this.loadData();
      } else if (!this.openDialog) {
        this.contactos = [];
        this.propietario = {};
      } else {
        console.error('openDialog debe ser booleano, openDialog: %o', this.openDialog);
      }
    },
  },
});
